import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ReliableCareSection.css';
import doctorVisit2 from '../images/gallery/doctor visit 2.jpg';

const ReliableCareSection = () => {
  return (
    <section className="reliable-care-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="order-lg-2 mb-4 mb-lg-0">
            <h2>Reliable Home Care services in Guntur</h2>
            <h3>Compassionate Care At Your Doorstep!</h3>
            <p>
              When you need quality support at home, our home care services in Guntur offer the
              perfect solution. We provide professional and compassionate caregivers who are
              dedicated to enhancing the quality of life for you or your loved ones. From
              personal care to companionship, our services are tailored to meet individual needs,
              ensuring comfort and safety in a familiar environment. Choose our home care
              services in Guntur for peace of mind and exceptional care right where it matters most.
            </p>
          </Col>
          <Col lg={6} className="order-lg-1">
            <div className="image-wrapper">
              <img 
                src={doctorVisit2}
                alt="Reliable Home Care Services" 
                className="section-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ReliableCareSection;
